import { Actions } from 'vuex-smart-module';
import { MaterialsFilters } from '@/modules/marketing_materials/types';
import MaterialsState from './state';
import MaterialsMutations from './mutations';
import MaterialsGetters from './getters';
import { MaterialsService } from '../service';

const materialService = new MaterialsService();

export default class MaterialsActions extends Actions<
  MaterialsState,
  MaterialsGetters,
  MaterialsMutations,
  // eslint-disable-next-line no-use-before-define
  MaterialsActions
> {
  async show(id: string) {
    this.mutations.TOGGLE_MATERIALS_LOADING(true);
    this.mutations.SET_NESTED_MATERIALS([]);
    this.mutations.SET_MATERIAL(null);

    const { data, material, nested_materials } = await materialService.show(id);

    this.mutations.SET_MATERIAL_URL(data);
    this.mutations.SET_MATERIAL(material);
    this.mutations.SET_NESTED_MATERIALS(nested_materials);
    this.mutations.TOGGLE_MATERIALS_LOADING(false);
  }

  async first_or_create(filters: MaterialsFilters) {
    this.mutations.TOGGLE_MATERIALS_LOADING(true);
    this.mutations.SET_NESTED_MATERIALS([]);
    this.mutations.SET_MATERIAL(null);

    const { data, material, nested_materials } = await materialService.first_or_create(filters);

    this.mutations.SET_MATERIAL_URL(data);
    this.mutations.SET_MATERIAL(material);
    this.mutations.SET_NESTED_MATERIALS(nested_materials);
    this.mutations.TOGGLE_MATERIALS_LOADING(false);
  }

  async download(path: string) {
    try {
      this.mutations.SET_DOWNLOADED_BYTES(0);
      this.mutations.TOGGLE_DOWNLOADING(true);
      this.mutations.TOGGLE_DOWNLOADING_FAILED(false);
      this.mutations.SET_DOWNLOADED_FILE_NAME(null);
      this.mutations.CLEAR_DOWNLOADED_URL();

      const response = await materialService.download(
        path,
        (progressEvent: ProgressEvent) => {
          this.mutations.SET_DOWNLOAD_LENGTH(progressEvent.total);
          this.mutations.SET_DOWNLOADED_BYTES(progressEvent.loaded);
        },
      );

      const contentDispositionHeader = response.headers['content-disposition'];

      if (!contentDispositionHeader) {
        console.error('Ошибка заголовка с именем файла');
        return;
      }

      const match = contentDispositionHeader.match(/filename\*?=["']?(?:UTF-8'')?([^;\n"']*)['" ]?/i);
      const filename = match && match[1] ? decodeURIComponent(match[1]) : 'downloaded_file';

      this.mutations.CREATE_DOWNLOADED_URL(response.data);
      this.mutations.SET_DOWNLOADED_FILE_NAME(filename);
    } catch (e) {
      this.mutations.TOGGLE_DOWNLOADING_FAILED(true);
    } finally {
      this.mutations.TOGGLE_DOWNLOADING(false);
    }
  }

  async cancelDownload() {
    materialService.cancelDownload();
  }
}
